import { StyledDnD } from "../styles/StyledDnD"

export default function DnD() {
  return <StyledDnD>Drag and drop to reorder list</StyledDnD>
}
